import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { FiscalAddressModel } from '../../../../pages/clients/clients.model'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { AddressTypeEnum } from '../../enums/addressTypeEnum'
import { PostalAddress, PostalCode } from '../../model/addresses'
import { sanitizeQuery } from '../../../../helpers/sanitizeQueryHelper'

export const apiSaveAddress = async (address: FiscalAddressModel): Promise<FiscalAddressModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Address/PostAddress`, address).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiGetAddresses = async (
  contractID: number,
  addressType: AddressTypeEnum
): Promise<FiscalAddressModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Address/GetAddressesByTypeAndContractID?contractID=${contractID}&addressType=${addressType}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetPostalAddressByPostalCode = async (
  postalCodeId: number
): Promise<PostalAddress> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Address/GetPostalAddressByPostalCode/${postalCodeId}`
  ).then(response => {
    return response.data
  })
}

export const apiGetPostalCodes = async (keyword: string): Promise<PostalCode[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  // Sanitize query to prevent SQL injections - allow alphanumeric and hyphens for postal codes
  const sanitizedKeyword = sanitizeQuery(keyword, ['-'])

  // Skip API call if keyword is empty after sanitization
  if (!sanitizedKeyword) {
    return []
  }

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Address/FetchPostalCodes?postalCode=${sanitizedKeyword}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}
